/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { CreateTruckTypeMutation, CreateTruckTypeMutationVariables } from "@models/graphql";

const defaultCreateTruckTypeOptions: MutationHookOptions<CreateTruckTypeMutation, CreateTruckTypeMutationVariables> = {};

export const useCreateTruckType = (options?: MutationHookOptions<CreateTruckTypeMutation, CreateTruckTypeMutationVariables>) => {
    const [mutation, { data, loading, error }] = useMutation<CreateTruckTypeMutation, CreateTruckTypeMutationVariables>(
        GraphQLDocuments.createTruckType
    );

    const createTruckType = async (variables: CreateTruckTypeMutationVariables) => {
        try {
            const response = await mutation({
                ...defaultCreateTruckTypeOptions,
                ...options,
                variables
            });

            return {
                error: response.errors,
                data: response.data
            };
        } catch (err) {
            return {
                error: err
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        createTruckType
    };
};
